export const DEFAULT_TYPE_FIELD = '__datx__type__';
export const DEFAULT_ID_FIELD = '__datx__id__';
